import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles } from '../../lib/styles';

const useStyle = makeStyles({
  root: {
    height: '0.8em',
    width: '0.8em',
  },
});

const Close = props => {
  const classes = useStyle();
  return (
    <SvgIcon {...props} classes={classes}>
      <path
        d="M1 1L16.5946 16.5946"
        stroke="#2D2D2D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 1L1.40542 16.5946"
        stroke="#2D2D2D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default Close;
